import routes from 'src/routes'
import oralThumbnail from '../../images/gallerium/onDemand/oral-thumbnail.png'
import posterThumbnail from '../../images/gallerium/onDemand/poster2-thumbnail.png'
import recordedLiveThumbnail from '../../images/gallerium/onDemand/video-thumbnail.png'
import virtualProduct from '../../images/gallerium/onDemand/virtual-product-icon.png'
import {
  // awardsVideos,
  // lunchBreakfastSymposiumVideos,
  // masterclassVideos,
  onDemandVideosType,
  liveRecordedDay1,
  liveRecordedDay2,
  liveRecordedDay3,
} from './videos'

export interface onDemandCategoryType {
  id: string
  categoryName: string
  thumbnail: string
  destination: string
  videos?: Array<onDemandVideosType>
}

const onDemandCategories: Array<onDemandCategoryType> = [
  {
    id: 'cat5',
    categoryName: 'Oral Presentations',
    thumbnail: oralThumbnail,
    destination: routes.onDemandOral,
  },
  {
    id: 'cat6',
    categoryName: 'E Poster Presentations',
    thumbnail: posterThumbnail,
    destination: routes.onDemandPoster,
  },
  {
    id: 'cat4',
    categoryName: 'Virtual Product Theatre',
    thumbnail: virtualProduct,
    destination: routes.virtualProductLanding,
  },
  {
    id: 'cat1',
    categoryName: 'Recorded Live Programme Day 1',
    thumbnail: recordedLiveThumbnail,
    videos: liveRecordedDay1,
    destination: routes.onDemandRecorded1,
  },
  {
    id: 'cat2',
    categoryName: 'Recorded Live Programme Day 2',
    thumbnail: recordedLiveThumbnail,
    videos: liveRecordedDay2,
    destination: routes.onDemandRecorded2,
  },
  {
    id: 'cat3',
    categoryName: 'Recorded Live Programme Day 3',
    thumbnail: recordedLiveThumbnail,
    videos: liveRecordedDay3,
    destination: routes.onDemandRecorded3,
  },
]

export { onDemandCategories }
